import BaseResource                                 from '@/lib/data/resource/BaseResource'
import i18n                                         from '@/lang/lang'
import { collect }                                  from '@/lib/utils/array'
import ChartsStyleEnum                              from '@/api/enums/ChartsEnum'
import NIIAssetNameResource                            from '@/api/resources/asset/NIIAssetNameResource'
import AssetCodeNameResource                        from '@/api/resources/asset/AssetCodeNameResource'
import NIIValueAtRiskSimulationSeasonalityResource from '@/api/resources/risks/NIIValueAtRiskSimulationSeasonalityResource'

export default class NIIForwardSimulationsAssetResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    const assetValue = payload?.itemCode || payload?.itemName || ''

    this.Asset = payload.itemName ?? ''
    this.AssetValue = assetValue.toLocaleLowerCase(i18n.code)

    this.BucketEdges = payload.bucketEdges ?? []
    this.CashFlowPaths = payload.cashFlowPaths ?? []
    this.CashFlowPathsValues = this.getCashFlowPaths()

    this.AssetDataHistograms = collect([payload.data], NIIValueAtRiskSimulationSeasonalityResource)

    this.AssetData = []
    if (this.AssetDataHistograms) {
      if (this.AssetDataHistograms.length) {
        this.AssetDataHistograms.forEach(item => {
          this.AssetData.push({
            Color: ChartsStyleEnum.Colors.LineChartSeasonality.user,
            ...item
          })
        })
      }
    }

    this.AggregateItem = payload.aggregateItem || false
    this.PerCategoryCodes = collect(payload?.perCategoryCodes || [], NIIAssetNameResource)
    this.PerCategoryItems = collect(payload?.perCategoryItems || [], NIIForwardSimulationsAssetResource)

    this.PerCategoryNames = payload.perCategoryNames ?? []
    this.PerCategoryCodeNames = collect(payload?.perCategoryCodeNames || [], AssetCodeNameResource)
  }

  /* PROPERTIES */

  /* METHODS */
  getCashFlowPaths () {
    return this.CashFlowPaths.map(item => { return { y: item } })
  }

  getSeasonalityHistogramsWithBucketEdges (v) {
    if (v && !!v.length) {
      return v.map(item => {
        item.bucketEdges = this.BucketEdges
        return item
      })
    }

    return []
  }
}
